import { RouteConfig } from "vue-router";
import localizationFactory from "@/router/modules/localization-factory";

export default [
	{
		path: "/",
		name: "Forex",
		meta: {
			layout: "main",
			className: "header-sm-none",
			mainClassName: 'forex-service breadcrumbs-dark',
		},
		component: () => import('../views/ForexServiceList.vue'),
	},
	{
		path: "buy",
		name: "ForexBuy",
		meta: localizationFactory('forex.buyCurrency', {
			layout: "main",
			className: "header-sm-none",
			mainClassName: 'forex-buy',
		}),
		component: () => import('../views/ForexBuy.vue'),
	},
	{
		path: "sell",
		name: "ForexSell",
		meta: localizationFactory('forex.sellCurrency', {
			layout: "main",
			className: "header-sm-none",
			mainClassName: 'forex-sell',
		}),
		component: () => import('../views/ForexSell.vue'),
	},
	{
		path: "drafts",
		name: "ForexDraft",
		meta: localizationFactory('home.statusPayment.draft', {
			layout: "main",
			className: "header-sm-none",
			mainClassName: 'forex-draft breadcrumbs-dark',
		}),
		component: () => import('../views/ForexDraft.vue'),
	},
	{
		path: "templates",
		name: "ForexTemplate",
		meta: localizationFactory('home.tabsList.templates', {
			layout: "main",
			className: "header-sm-none",
			mainClassName: 'forex-template breadcrumbs-dark',
		}),
		component: () => import('../views/ForexTemplate.vue'),
	},
	{
		path: "approval",
		name: "ForexApproval",
		meta: localizationFactory('home.statusPayment.approval', {
			layout: "main",
			className: "header-sm-none",
			showBreadcrumbEnd: true,
			mainClassName: 'forex-approval breadcrumbs-dark',
		}),
		component: () => import('../views/ForexApproval.vue'),
	},
] as RouteConfig[];
